import React, { useState,useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { EditTwoTone } from '@ant-design/icons';
import { Input,Pagination,Card } from 'antd';
import { app } from '../../config';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';
import NoRecordFound from '../../components/common/NoRecordFound';

const OrgAds = () => {
  const {Search}=Input
  const {t}=useTranslation(["common"])
  const [editbtn, setEditBtn] = useState('none');
  const [fetchAds, setfetchAds] = useState([]);
  const [search,setSearch]=useState('');
  const [searchShow,setSearchShow]=useState(false);
  const [pagesCount, setPagesCount] = useState(0);
  const [renderList,setRenderList]=useState([]);
  const [current, setCurrent] = useState(1);
  const [tableShow,setTableShow]=useState(true);
  const [err,setErr]=useState('');
  const token=getTokenfromUserObj()
  let navigate=useNavigate();
  const user = JSON.parse(localStorage.getItem('user'));
  const editAd = (e) => {
    localStorage.setItem('orgAdId', JSON.stringify(e.orgAdId));
    user.userType==="A"?navigate('/orgads/edit',{replace:true}):navigate('/advertisement/edit', { replace: true });
  };
  console.log("ads");
  useEffect(() => {
    const fetchAds=async()=>{
      if (user.userType === 'A') setEditBtn('block');
      let adsURL;
      if(user.userType==="A")adsURL=`${app.URL}/orgad/viewallads`
      else if(user.userType==="O")adsURL=`${app.URL}/orgad/view/${user.organizationId}`
      const adsResp=await axios.get(adsURL,{headers:{auth:token}})
      console.log(adsResp);
      adsResp.data?setfetchAds(adsResp.data.data):" ";
      adsResp.data?setPagesCount(adsResp.data.data.length):" ";
      adsResp.data?setRenderList((adsResp.data.data).slice(0,50)):" ";
    }  
    fetchAds();  

    }, []);
  const handleSearch=async()=>{
      try{

          const result=search?await axios.get(`${app.URL}/user/search/${search}`):[];
          searchedUser=result.data;
         }
         catch(e){
           console.log("Error");
         if(e.message)setErr(e.response.data.message);
         setTableShow(false);
         }
         
         console.log(searchedUser)
         if(searchedUser){
           setSearchShow(true);
           setRenderList(searchedUser)
         }
         console.log(searchedUser);
  }
  const onSearch = async (value) => {
    console.log(value);
    try{
      const result=user.userType==="A"?await axios.post(`${app.URL}/orgad/search/${value}`,{},{headers:{auth:token}}):await axios.post(`${app.URL}/orgad/search/${value}`,{organizationId:user.organizationId},{headers:{auth:token}});
      console.log(result);
       let searchedRole=result.data.data;
       console.log(searchedRole);
       setRenderList(searchedRole);
       setPagesCount(searchedRole.length);
     }
     catch(e){
       console.log("Error");
       console.log(e);
    //  if(e.message)setErr(e.response.data.message);
     setTableShow(false);
     }
  }
  const onChange = async(page,pageSize) => {
    console.log(page);
    setCurrent(page);
    if(!page)page=1;
    let limit=pageSize;
    let reqObj={
      limit,
      offset:limit*(page-1)
    }
    setRenderList(fetchAds.slice(reqObj.offset, reqObj.offset + limit));

  };
  const handleSearchChange=(e)=>{
      if(!e.target.value){
        setRenderList(fetchAds.slice(0,50))
          setPagesCount(fetchAds.length);};
  }
  const addRole=()=>user.userType==="A"?navigate('/orgads/add',{replace:true}):navigate('/advertisement/add',{replace:true});


  
  console.log(renderList)


  return (

<div className=''>
  <div className='ml-3 col-lg-12 col-md-12 col-sm-12 '>
  <div className='row mt-4'>
    <div className="col-lg-6 col-md-10 col-sm-10 fs-3 fw-bold">
    {t('Organization Ads')}
    </div>
    <div className="col-lg-2 col-md-2 col-sm-2">
    <button class="btn btn-primary button" onClick={addRole}>Add Ads</button>  
    </div>  
    </div>
    <div className='row text-center mb-2'>
    <div className="col-lg-7 mt-4">
    <Search
      className='search'
      placeholder='Search by Ad. Title'
      onChange={handleSearchChange}
      onSearch={onSearch}
      style={{
        width: 300,
      }}
    />
    </div>
    </div>
   
  <div className='col-lg-7 col-md-12 col-sm-12 '>
      <div class=' styled-table '>
         <table class='table text-black' >
           <thead class='thead-light'>
             <tr>
             {/* <th>{t("ID")}</th> */}
                            {user.userType==="A"?  <th>{t("Organization")}</th>   :""}
                             <th>{t("Title")}</th>
                             <th>{t("Content Type")}</th>
                             <th>{t("Status")}</th>
                             {/* <th>{t("Phone")}</th>
                             <th>{t("User Type")}</th> */}
                             <th> </th>
             </tr>
           </thead>
           <tbody >

             {renderList
               ? renderList.map((output) => (

                   <tr className='row-hover' onClick={() => editAd(output)}>
                     {/* <td style={{width:"160px"}}>{output.roleId}</td> */}
                     {/* onClick={()=>{editUser(output)}} style={{color:"blue",textDecoration:"underline", width:"160px"}} */}
                     {user.userType==="A"? <td style={{width:"250px"}} >{output.organizationName?output.organizationName :"null"}</td>   :""}
                     <td style={{width:"200px"}} >{output.name?output.name :"null"}</td>
                     <td style={{width:"200px"}} >{output.contentType?output.contentType :"null"}</td>
                     <td style={{width:"200px"}}>{output.isActive===1?"Active":"Inactive"}</td>
                     {/* <td style={{width:"160px"}}>{output.phone}</td>
                   <td style={{width:"160px"}}>{output.userType==="A"?"Admin":output.userType==="D"?"Donor":output.userType==="O"?"Org User":"User"}</td> */}
                     <td>
                     <EditTwoTone displayName="edit" twoToneColor="blue" style={{fontSize:"20px"}} onClick={() => editAd(output)} />
                       {/* <button type='button' style={{ display: editbtn }} class='btn btn-primary color1 button' onClick={() => editOrg(output)}>
                         {t('Edit')}
                       </button> */}
                     </td>
                   </tr>
                 ))
               : ' '}
           </tbody>
         </table>
         {renderList&&renderList.length == 0?<NoRecordFound/>:" "}
       </div>     
  </div>
  <Pagination style={{marginTop:"20px"}} onChange={onChange} defaultCurrent={current} pageSize={50} total={pagesCount} />
  </div>
  {/* </div>  
</div> */}
</div>
    
     
  );
};

export default OrgAds;
